[
  {
    "id": "mostUsed",
    "icons": [
      { "id": "3000_Zug_r_v1" },
      { "id": "3001_Tram_r_v1" },
      { "id": "3002_Bus_r_v1" },
      { "id": "circle" },
      { "id": "1000_Pfeil-links_v1" },
      { "id": "1001_Pfeil-rechts_v1" },
      { "id": "5021_Baustelle" },
      { "id": "5022_Einfahrt_Verboten" },
      { "id": "201_Buslichtzeichen" },
      { "id": "202_Ampeln" },
      { "id": "204_Andreaskreuz" },
      { "id": "barriere_v1" },
      { "id": "ersatzverkehr_ch_v1" },
      { "id": "cross_v1" },
      { "id": "cross_black_v1" }
    ]
  },
  {
    "id": "Stadtbus Winterthur",
    "icons": [
      {
        "id": "winterthur_1_v1"
      },
      {
        "id": "winterthur_2_v1"
      },
      {
        "id": "winterthur_3_v1"
      },
      {
        "id": "winterthur_4_v1"
      },
      {
        "id": "winterthur_5_v1"
      },
      {
        "id": "winterthur_7_v1"
      },
      {
        "id": "winterthur_9_v1"
      },
      {
        "id": "winterthur_10_v1"
      },
      {
        "id": "winterthur_12_v1"
      },
      {
        "id": "winterthur_22_v1"
      },
      {
        "id": "winterthur_610_v1"
      },
      {
        "id": "winterthur_611_v1"
      },
      {
        "id": "winterthur_660_v1"
      },
      {
        "id": "winterthur_670_postauto_v1"
      },
      {
        "id": "winterthur_671_postauto_v1"
      },
      {
        "id": "winterthur_674_v1"
      },
      {
        "id": "winterthur_676_postauto_v1"
      },
      {
        "id": "winterthur_680_postauto_v1"
      },
      {
        "id": "winterthur_N1_v1"
      },
      {
        "id": "winterthur_N2_v1"
      },
      {
        "id": "winterthur_N3_v1"
      },
      {
        "id": "winterthur_N7_v1"
      },
      {
        "id": "winterthur_N58_v1"
      },
      {
        "id": "winterthur_N59_v1"
      },
      {
        "id": "winterthur_N63_v1"
      },
      {
        "id": "winterthur_N64_v1"
      },
      {
        "id": "winterthur_N66_v1"
      },
      {
        "id": "winterthur_N67_v1"
      },
      {
        "id": "winterthur_N68_v1"
      }
    ]
  },
  {
    "id": "01_Richtungen",
    "icons": [
      {
        "id": "1000_Pfeil-links_v1"
      },
      {
        "id": "1001_Pfeil-rechts_v1"
      },
      {
        "id": "1002_Pfeil-oben_v1"
      },
      {
        "id": "1003_Pfeil-unten_v1"
      },
      {
        "id": "1004_Pfeil-links-aufwaerts_v1"
      },
      {
        "id": "1005_Pfeil-rechts-aufwaerts_v1"
      },
      {
        "id": "1006_Pfeil-links-abwaerts_v1"
      },
      {
        "id": "1007_Pfeil-rechts-abwaerts_v1"
      },
      {
        "id": "1008_Pfeil-links_v1"
      },
      {
        "id": "1009_Pfeil-rechts_v1"
      },
      {
        "id": "1010_Pfeil-oben_v1"
      },
      {
        "id": "1011_Pfeil-unten_v1"
      },
      {
        "id": "1012_Pfeil-links-aufwaerts_v1"
      },
      {
        "id": "1013_Pfeil-rechts-aufwaerts_v1"
      },
      {
        "id": "1014_Pfeil-links-abwaerts_v1"
      },
      {
        "id": "1015_Pfeil-rechts-abwaerts_v1"
      },
      {
        "id": "1016_Pfeil-links_v1"
      },
      {
        "id": "1017_Pfeil-rechts_v1"
      },
      {
        "id": "1018_Pfeil-oben_v1"
      },
      {
        "id": "1019_Pfeil-unten_v1"
      },
      {
        "id": "1020_Pfeil-links-aufwaerts_v1"
      },
      {
        "id": "1021_Pfeil-rechts-aufwaerts_v1"
      },
      {
        "id": "1022_Pfeil-links-abwaerts_v1"
      },
      {
        "id": "1023_Pfeil-rechts-abwaerts_v1"
      }
    ]
  },
  {
    "id": "01_Gleise",
    "icons": [
      {
        "id": "00_Gleis-0_g_de_v1"
      },
      {
        "id": "00_Gleis-0_g_fr_v1"
      },
      {
        "id": "00_Gleis-0_g_it_v1"
      },
      {
        "id": "01_Gleis-1_g_de_v1"
      },
      {
        "id": "01_Gleis-1_g_fr_v1"
      },
      {
        "id": "01_Gleis-1_g_it_v1"
      },
      {
        "id": "02_Gleis-2_g_de_v1"
      },
      {
        "id": "02_Gleis-2_g_fr_v1"
      },
      {
        "id": "02_Gleis-2_g_it_v1"
      },
      {
        "id": "03_Gleis-3_g_de_v1"
      },
      {
        "id": "03_Gleis-3_g_fr_v1"
      },
      {
        "id": "03_Gleis-3_g_it_v1"
      },
      {
        "id": "04_Gleis-4_g_de_v1"
      },
      {
        "id": "04_Gleis-4_g_fr_v1"
      },
      {
        "id": "04_Gleis-4_g_it_v1"
      },
      {
        "id": "05_Gleis-5_g_de_v1"
      },
      {
        "id": "05_Gleis-5_g_fr_v1"
      },
      {
        "id": "05_Gleis-5_g_it_v1"
      },
      {
        "id": "06_Gleis-6_g_de_v1"
      },
      {
        "id": "06_Gleis-6_g_fr_v1"
      },
      {
        "id": "06_Gleis-6_g_it_v1"
      },
      {
        "id": "07_Gleis-7_g_de_v1"
      },
      {
        "id": "07_Gleis-7_g_fr_v1"
      },
      {
        "id": "07_Gleis-7_g_it_v1"
      },
      {
        "id": "08_Gleis-8_g_de_v1"
      },
      {
        "id": "08_Gleis-8_g_fr_v1"
      },
      {
        "id": "08_Gleis-8_g_it_v1"
      },
      {
        "id": "09_Gleis-9_g_de_v1"
      },
      {
        "id": "09_Gleis-9_g_fr_v1"
      },
      {
        "id": "09_Gleis-9_g_it_v1"
      },
      {
        "id": "10_Gleis-10_g_de_v1"
      },
      {
        "id": "10_Gleis-10_g_fr_v1"
      },
      {
        "id": "10_Gleis-10_g_it_v1"
      },
      {
        "id": "11_Gleis-11_g_de_v1"
      },
      {
        "id": "11_Gleis-11_g_fr_v1"
      },
      {
        "id": "11_Gleis-11_g_it_v1"
      },
      {
        "id": "12_Gleis-12_g_de_v1"
      },
      {
        "id": "12_Gleis-12_g_fr_v1"
      },
      {
        "id": "12_Gleis-12_g_it_v1"
      },
      {
        "id": "13_Gleis-13_g_de_v1"
      },
      {
        "id": "13_Gleis-13_g_fr_v1"
      },
      {
        "id": "13_Gleis-13_g_it_v1"
      },
      {
        "id": "14_Gleis-14_g_de_v1"
      },
      {
        "id": "14_Gleis-14_g_fr_v1"
      },
      {
        "id": "14_Gleis-14_g_it_v1"
      },
      {
        "id": "15_Gleis-15_g_de_v1"
      },
      {
        "id": "15_Gleis-15_g_fr_v1"
      },
      {
        "id": "15_Gleis-15_g_it_v1"
      },
      {
        "id": "16_Gleis-16_g_de_v1"
      },
      {
        "id": "16_Gleis-16_g_fr_v1"
      },
      {
        "id": "16_Gleis-16_g_it_v1"
      },
      {
        "id": "17_Gleis-17_g_de_v1"
      },
      {
        "id": "17_Gleis-17_g_fr_v1"
      },
      {
        "id": "17_Gleis-17_g_it_v1"
      },
      {
        "id": "18_Gleis-18_g_de_v1"
      },
      {
        "id": "18_Gleis-18_g_fr_v1"
      },
      {
        "id": "18_Gleis-18_g_it_v1"
      },
      {
        "id": "19_Gleis-19_g_de_v1"
      },
      {
        "id": "19_Gleis-19_g_fr_v1"
      },
      {
        "id": "19_Gleis-19_g_it_v1"
      },
      {
        "id": "20_Gleis-20_k_de_v1"
      },
      {
        "id": "20_Gleis-20_k_fr_v1"
      },
      {
        "id": "20_Gleis-20_k_it_v1"
      },
      {
        "id": "21_Gleis-21_k_de_v1"
      },
      {
        "id": "21_Gleis-21_k_fr_v1"
      },
      {
        "id": "21_Gleis-21_k_it_v1"
      },
      {
        "id": "22_Gleis-22_k_de_v1"
      },
      {
        "id": "22_Gleis-22_k_fr_v1"
      },
      {
        "id": "22_Gleis-22_k_it_v1"
      },
      {
        "id": "23_Gleis-23_k_de_v1"
      },
      {
        "id": "23_Gleis-23_k_fr_v1"
      },
      {
        "id": "23_Gleis-23_k_it_v1"
      },
      {
        "id": "24_Gleis-24_k_de_v1"
      },
      {
        "id": "24_Gleis-24_k_fr_v1"
      },
      {
        "id": "24_Gleis-24_k_it_v1"
      },
      {
        "id": "25_Gleis-25_k_de_v1"
      },
      {
        "id": "25_Gleis-25_k_fr_v1"
      },
      {
        "id": "25_Gleis-25_k_it_v1"
      },
      {
        "id": "26_Gleis-26_k_de_v1"
      },
      {
        "id": "26_Gleis-26_k_fr_v1"
      },
      {
        "id": "26_Gleis-26_k_it_v1"
      },
      {
        "id": "27_Gleis-27_k_de_v1"
      },
      {
        "id": "27_Gleis-27_k_fr_v1"
      },
      {
        "id": "27_Gleis-27_k_it_v1"
      },
      {
        "id": "28_Gleis-28_k_de_v1"
      },
      {
        "id": "28_Gleis-28_k_fr_v1"
      },
      {
        "id": "28_Gleis-28_k_it_v1"
      },
      {
        "id": "29_Gleis-29_k_de_v1"
      },
      {
        "id": "29_Gleis-29_k_fr_v1"
      },
      {
        "id": "29_Gleis-29_k_it_v1"
      },
      {
        "id": "30_Gleis-30_k_de_v1"
      },
      {
        "id": "30_Gleis-30_k_fr_v1"
      },
      {
        "id": "30_Gleis-30_k_it_v1"
      },
      {
        "id": "31_Gleis-31_k_de_v1"
      },
      {
        "id": "31_Gleis-31_k_fr_v1"
      },
      {
        "id": "31_Gleis-31_k_it_v1"
      },
      {
        "id": "32_Gleis-32_k_de_v1"
      },
      {
        "id": "32_Gleis-32_k_fr_v1"
      },
      {
        "id": "32_Gleis-32_k_it_v1"
      },
      {
        "id": "33_Gleis-33_k_de_v1"
      },
      {
        "id": "33_Gleis-33_k_fr_v1"
      },
      {
        "id": "33_Gleis-33_k_it_v1"
      },
      {
        "id": "34_Gleis-34_k_de_v1"
      },
      {
        "id": "34_Gleis-34_k_fr_v1"
      },
      {
        "id": "34_Gleis-34_k_it_v1"
      },
      {
        "id": "35_Gleis-35_k_de_v1"
      },
      {
        "id": "35_Gleis-35_k_fr_v1"
      },
      {
        "id": "35_Gleis-35_k_it_v1"
      },
      {
        "id": "36_Gleis-36_k_de_v1"
      },
      {
        "id": "36_Gleis-36_k_fr_v1"
      },
      {
        "id": "36_Gleis-36_k_it_v1"
      },
      {
        "id": "37_Gleis-37_k_de_v1"
      },
      {
        "id": "37_Gleis-37_k_fr_v1"
      },
      {
        "id": "37_Gleis-37_k_it_v1"
      },
      {
        "id": "38_Gleis-38_k_de_v1"
      },
      {
        "id": "38_Gleis-38_k_fr_v1"
      },
      {
        "id": "38_Gleis-38_k_it_v1"
      },
      {
        "id": "39_Gleis-39_k_de_v1"
      },
      {
        "id": "39_Gleis-39_k_fr_v1"
      },
      {
        "id": "39_Gleis-39_k_it_v1"
      },
      {
        "id": "40_Gleis-40_k_de_v1"
      },
      {
        "id": "40_Gleis-40_k_fr_v1"
      },
      {
        "id": "40_Gleis-40_k_it_v1"
      },
      {
        "id": "41_Gleis-41_k_de_v1"
      },
      {
        "id": "41_Gleis-41_k_fr_v1"
      },
      {
        "id": "41_Gleis-41_k_it_v1"
      },
      {
        "id": "42_Gleis-42_k_de_v1"
      },
      {
        "id": "42_Gleis-42_k_fr_v1"
      },
      {
        "id": "42_Gleis-42_k_it_v1"
      },
      {
        "id": "43_Gleis-43_k_de_v1"
      },
      {
        "id": "43_Gleis-43_k_fr_v1"
      },
      {
        "id": "43_Gleis-43_k_it_v1"
      },
      {
        "id": "44_Gleis-44_k_de_v1"
      },
      {
        "id": "44_Gleis-44_k_fr_v1"
      },
      {
        "id": "44_Gleis-44_k_it_v1"
      },
      {
        "id": "45_Gleis-45_k_de_v1"
      },
      {
        "id": "45_Gleis-45_k_fr_v1"
      },
      {
        "id": "45_Gleis-45_k_it_v1"
      },
      {
        "id": "46_Gleis-46_k_de_v1"
      },
      {
        "id": "46_Gleis-46_k_fr_v1"
      },
      {
        "id": "46_Gleis-46_k_it_v1"
      },
      {
        "id": "47_Gleis-47_k_de_v1"
      },
      {
        "id": "47_Gleis-47_k_fr_v1"
      },
      {
        "id": "47_Gleis-47_k_it_v1"
      },
      {
        "id": "48_Gleis-48_k_de_v1"
      },
      {
        "id": "48_Gleis-48_k_fr_v1"
      },
      {
        "id": "48_Gleis-48_k_it_v1"
      },
      {
        "id": "49_Gleis-49_k_de_v1"
      },
      {
        "id": "49_Gleis-49_k_fr_v1"
      },
      {
        "id": "49_Gleis-49_k_it_v1"
      },
      {
        "id": "50_Gleis-50_k_de_v1"
      },
      {
        "id": "50_Gleis-50_k_fr_v1"
      },
      {
        "id": "50_Gleis-50_k_it_v1"
      },
      {
        "id": "51_Gleis-51_k_de_v1"
      },
      {
        "id": "51_Gleis-51_k_fr_v1"
      },
      {
        "id": "51_Gleis-51_k_it_v1"
      },
      {
        "id": "52_Gleis-52_k_de_v1"
      },
      {
        "id": "52_Gleis-52_k_fr_v1"
      },
      {
        "id": "52_Gleis-52_k_it_v1"
      },
      {
        "id": "53_Gleis-53_k_de_v1"
      },
      {
        "id": "53_Gleis-53_k_fr_v1"
      },
      {
        "id": "53_Gleis-53_k_it_v1"
      },
      {
        "id": "54_Gleis-54_k_de_v1"
      },
      {
        "id": "54_Gleis-54_k_fr_v1"
      },
      {
        "id": "54_Gleis-54_k_it_v1"
      },
      {
        "id": "55_Gleis-55_k_de_v1"
      },
      {
        "id": "55_Gleis-55_k_fr_v1"
      },
      {
        "id": "55_Gleis-55_k_it_v1"
      },
      {
        "id": "56_Gleis-56_k_de_v1"
      },
      {
        "id": "56_Gleis-56_k_fr_v1"
      },
      {
        "id": "56_Gleis-56_k_it_v1"
      },
      {
        "id": "57_Gleis-57_k_de_v1"
      },
      {
        "id": "57_Gleis-57_k_fr_v1"
      },
      {
        "id": "57_Gleis-57_k_it_v1"
      },
      {
        "id": "58_Gleis-58_k_de_v1"
      },
      {
        "id": "58_Gleis-58_k_fr_v1"
      },
      {
        "id": "58_Gleis-58_k_it_v1"
      },
      {
        "id": "59_Gleis-59_k_de_v1"
      },
      {
        "id": "59_Gleis-59_k_fr_v1"
      },
      {
        "id": "59_Gleis-59_k_it_v1"
      },
      {
        "id": "60_Gleis-60_k_de_v1"
      },
      {
        "id": "60_Gleis-60_k_fr_v1"
      },
      {
        "id": "60_Gleis-60_k_it_v1"
      },
      {
        "id": "61_Gleis-61_k_de_v1"
      },
      {
        "id": "61_Gleis-61_k_fr_v1"
      },
      {
        "id": "61_Gleis-61_k_it_v1"
      },
      {
        "id": "62_Gleis-62_k_de_v1"
      },
      {
        "id": "62_Gleis-62_k_fr_v1"
      },
      {
        "id": "62_Gleis-62_k_it_v1"
      },
      {
        "id": "63_Gleis-63_k_de_v1"
      },
      {
        "id": "63_Gleis-63_k_fr_v1"
      },
      {
        "id": "63_Gleis-63_k_it_v1"
      },
      {
        "id": "64_Gleis-64_k_de_v1"
      },
      {
        "id": "64_Gleis-64_k_fr_v1"
      },
      {
        "id": "64_Gleis-64_k_it_v1"
      },
      {
        "id": "65_Gleis-65_k_de_v1"
      },
      {
        "id": "65_Gleis-65_k_fr_v1"
      },
      {
        "id": "65_Gleis-65_k_it_v1"
      },
      {
        "id": "66_Gleis-66_k_de_v1"
      },
      {
        "id": "66_Gleis-66_k_fr_v1"
      },
      {
        "id": "66_Gleis-66_k_it_v1"
      },
      {
        "id": "67_Gleis-67_k_de_v1"
      },
      {
        "id": "67_Gleis-67_k_fr_v1"
      },
      {
        "id": "67_Gleis-67_k_it_v1"
      },
      {
        "id": "68_Gleis-68_k_de_v1"
      },
      {
        "id": "68_Gleis-68_k_fr_v1"
      },
      {
        "id": "68_Gleis-68_k_it_v1"
      },
      {
        "id": "69_Gleis-69_k_de_v1"
      },
      {
        "id": "69_Gleis-69_k_fr_v1"
      },
      {
        "id": "69_Gleis-69_k_it_v1"
      },
      {
        "id": "70_Gleis-70_k_de_v1"
      },
      {
        "id": "70_Gleis-70_k_fr_v1"
      },
      {
        "id": "70_Gleis-70_k_it_v1"
      },
      {
        "id": "71_Gleis-71_k_de_v1"
      },
      {
        "id": "71_Gleis-71_k_fr_v1"
      },
      {
        "id": "71_Gleis-71_k_it_v1"
      },
      {
        "id": "72_Gleis-72_k_de_v1"
      },
      {
        "id": "72_Gleis-72_k_fr_v1"
      },
      {
        "id": "72_Gleis-72_k_it_v1"
      },
      {
        "id": "73_Gleis-73_k_de_v1"
      },
      {
        "id": "73_Gleis-73_k_fr_v1"
      },
      {
        "id": "73_Gleis-73_k_it_v1"
      },
      {
        "id": "74_Gleis-74_k_de_v1"
      },
      {
        "id": "74_Gleis-74_k_fr_v1"
      },
      {
        "id": "74_Gleis-74_k_it_v1"
      },
      {
        "id": "75_Gleis-75_k_de_v1"
      },
      {
        "id": "75_Gleis-75_k_fr_v1"
      },
      {
        "id": "75_Gleis-75_k_it_v1"
      },
      {
        "id": "76_Gleis-76_k_de_v1"
      },
      {
        "id": "76_Gleis-76_k_fr_v1"
      },
      {
        "id": "76_Gleis-76_k_it_v1"
      },
      {
        "id": "77_Gleis-77_k_de_v1"
      },
      {
        "id": "77_Gleis-77_k_fr_v1"
      },
      {
        "id": "77_Gleis-77_k_it_v1"
      },
      {
        "id": "78_Gleis-78_k_de_v1"
      },
      {
        "id": "78_Gleis-78_k_fr_v1"
      },
      {
        "id": "78_Gleis-78_k_it_v1"
      },
      {
        "id": "79_Gleis-79_k_de_v1"
      },
      {
        "id": "79_Gleis-79_k_fr_v1"
      },
      {
        "id": "79_Gleis-79_k_it_v1"
      },
      {
        "id": "80_Gleis-80_k_de_v1"
      },
      {
        "id": "80_Gleis-80_k_fr_v1"
      },
      {
        "id": "80_Gleis-80_k_it_v1"
      },
      {
        "id": "81_Gleis-81_k_de_v1"
      },
      {
        "id": "81_Gleis-81_k_fr_v1"
      },
      {
        "id": "81_Gleis-81_k_it_v1"
      },
      {
        "id": "82_Gleis-82_k_de_v1"
      },
      {
        "id": "82_Gleis-82_k_fr_v1"
      },
      {
        "id": "82_Gleis-82_k_it_v1"
      },
      {
        "id": "83_Gleis-83_k_de_v1"
      },
      {
        "id": "83_Gleis-83_k_fr_v1"
      },
      {
        "id": "83_Gleis-83_k_it_v1"
      },
      {
        "id": "84_Gleis-84_k_de_v1"
      },
      {
        "id": "84_Gleis-84_k_fr_v1"
      },
      {
        "id": "84_Gleis-84_k_it_v1"
      },
      {
        "id": "85_Gleis-85_k_de_v1"
      },
      {
        "id": "85_Gleis-85_k_fr_v1"
      },
      {
        "id": "85_Gleis-85_k_it_v1"
      },
      {
        "id": "86_Gleis-86_k_de_v1"
      },
      {
        "id": "86_Gleis-86_k_fr_v1"
      },
      {
        "id": "86_Gleis-86_k_it_v1"
      },
      {
        "id": "87_Gleis-87_k_de_v1"
      },
      {
        "id": "87_Gleis-87_k_fr_v1"
      },
      {
        "id": "87_Gleis-87_k_it_v1"
      },
      {
        "id": "88_Gleis-88_k_de_v1"
      },
      {
        "id": "88_Gleis-88_k_fr_v1"
      },
      {
        "id": "88_Gleis-88_k_it_v1"
      },
      {
        "id": "89_Gleis-89_k_de_v1"
      },
      {
        "id": "89_Gleis-89_k_fr_v1"
      },
      {
        "id": "89_Gleis-89_k_it_v1"
      },
      {
        "id": "90_Gleis-90_k_de_v1"
      },
      {
        "id": "90_Gleis-90_k_fr_v1"
      },
      {
        "id": "90_Gleis-90_k_it_v1"
      },
      {
        "id": "91_Gleis-91_k_de_v1"
      },
      {
        "id": "91_Gleis-91_k_fr_v1"
      },
      {
        "id": "91_Gleis-91_k_it_v1"
      },
      {
        "id": "92_Gleis-92_k_de_v1"
      },
      {
        "id": "92_Gleis-92_k_fr_v1"
      },
      {
        "id": "92_Gleis-92_k_it_v1"
      },
      {
        "id": "93_Gleis-93_k_de_v1"
      },
      {
        "id": "93_Gleis-93_k_fr_v1"
      },
      {
        "id": "93_Gleis-93_k_it_v1"
      },
      {
        "id": "94_Gleis-94_k_de_v1"
      },
      {
        "id": "94_Gleis-94_k_fr_v1"
      },
      {
        "id": "94_Gleis-94_k_it_v1"
      },
      {
        "id": "95_Gleis-95_k_de_v1"
      },
      {
        "id": "95_Gleis-95_k_fr_v1"
      },
      {
        "id": "95_Gleis-95_k_it_v1"
      },
      {
        "id": "96_Gleis-96_k_de_v1"
      },
      {
        "id": "96_Gleis-96_k_fr_v1"
      },
      {
        "id": "96_Gleis-96_k_it_v1"
      },
      {
        "id": "97_Gleis-97_k_de_v1"
      },
      {
        "id": "97_Gleis-97_k_fr_v1"
      },
      {
        "id": "97_Gleis-97_k_it_v1"
      },
      {
        "id": "98_Gleis-98_k_de_v1"
      },
      {
        "id": "98_Gleis-98_k_fr_v1"
      },
      {
        "id": "98_Gleis-98_k_it_v1"
      },
      {
        "id": "99_Gleis-99_k_de_v1"
      },
      {
        "id": "99_Gleis-99_k_fr_v1"
      },
      {
        "id": "99_Gleis-99_k_it_v1"
      }
    ]
  },
  {
    "id": "02_Sektoren",
    "icons": [
      {
        "id": "00_Sektor-A_g_de_v1"
      },
      {
        "id": "00_Sektor-A_g_fr_v1"
      },
      {
        "id": "00_Sektor-A_g_it_v1"
      },
      {
        "id": "01_Sektor-B_g_de_v1"
      },
      {
        "id": "01_Sektor-B_g_fr_v1"
      },
      {
        "id": "01_Sektor-B_g_it_v1"
      },
      {
        "id": "02_Sektor-C_g_de_v1"
      },
      {
        "id": "02_Sektor-C_g_fr_v1"
      },
      {
        "id": "02_Sektor-C_g_it_v1"
      },
      {
        "id": "03_Sektor-D_g_de_v1"
      },
      {
        "id": "03_Sektor-D_g_fr_v1"
      },
      {
        "id": "03_Sektor-D_g_it_v1"
      },
      {
        "id": "04_Sektor-E_g_de_v1"
      },
      {
        "id": "04_Sektor-E_g_fr_v1"
      },
      {
        "id": "04_Sektor-E_g_it_v1"
      },
      {
        "id": "05_Sektor-F_g_de_v1"
      },
      {
        "id": "05_Sektor-F_g_fr_v1"
      },
      {
        "id": "05_Sektor-F_g_it_v1"
      },
      {
        "id": "06_Sektor-G_g_de_v1"
      },
      {
        "id": "06_Sektor-G_g_fr_v1"
      },
      {
        "id": "06_Sektor-G_g_it_v1"
      },
      {
        "id": "07_Sektor-H_g_de_v1"
      },
      {
        "id": "07_Sektor-H_g_fr_v1"
      },
      {
        "id": "07_Sektor-H_g_it_v1"
      },
      {
        "id": "08_Sektor-J_g_de_v1"
      },
      {
        "id": "08_Sektor-J_g_fr_v1"
      },
      {
        "id": "08_Sektor-J_g_it_v1"
      }
    ]
  },
  {
    "id": "04_Klassen",
    "icons": [
      {
        "id": "2007_1-Klasse_v1"
      },
      {
        "id": "2008_2-Klasse_v1"
      }
    ]
  },
  {
    "id": "01_Verkehrsmittel",
    "icons": [
      {
        "id": "3000_Zug_r_v1"
      },
      {
        "id": "3001_Tram_r_v1"
      },
      {
        "id": "3002_Bus_r_v1"
      },
      {
        "id": "3003_Flugzeug_r_v1"
      },
      {
        "id": "3004_Schiff_r_v1"
      },
      {
        "id": "3005_Autofaehre_r_v1"
      },
      {
        "id": "3006_Autoverlad_r_v1"
      },
      {
        "id": "3007_Lastwagenverlad_r_v1"
      },
      {
        "id": "3008_Zahnradbahn_r_v1"
      },
      {
        "id": "3009_Standseilbahn_r_v1"
      },
      {
        "id": "3010_Luftseilbahn_r_v1"
      },
      {
        "id": "3011_Gondelbahn_r_v1"
      },
      {
        "id": "3012_Sessellift_r_v1"
      },
      {
        "id": "3013_Skilift_r_v1"
      },
      {
        "id": "3014_Taxi_r_v1"
      },
      {
        "id": "3015_Car-Sharing_r_v1"
      },
      {
        "id": "3016_Autovermietung_r_de_v1"
      },
      {
        "id": "3016_Autovermietung_r_fr_v1"
      },
      {
        "id": "3016_Autovermietung_r_it_v1"
      },
      {
        "id": "3017_Velo_r_v1"
      },
      {
        "id": "3018_Velovermietung_r_de_v1"
      },
      {
        "id": "3018_Velovermietung_r_fr_v1"
      },
      {
        "id": "3018_Velovermietung_r_it_v1"
      },
      {
        "id": "3063_Metro_r_v1"
      }
    ]
  },
  {
    "id": "02_Parkieren",
    "icons": [
      {
        "id": "3019_Parkplatz_v1"
      },
      {
        "id": "3020_Parkhaus_v1"
      },
      {
        "id": "3021_Park-Rail_v1"
      },
      {
        "id": "3022_Mofa-Parkplatz_r_v1"
      },
      {
        "id": "3023_Velo-Parkplatz_r_v1"
      },
      {
        "id": "3024_Velostation_r_v1"
      },
      {
        "id": "3062_Velo-Reservation_r_v1"
      }
    ]
  },
  {
    "id": "03_Barrierefreiheit",
    "icons": [
      {
        "id": "4000_Barrierefrei_l_v1"
      },
      {
        "id": "4000_Barrierefrei_r_v1"
      },
      {
        "id": "4001_Kinderwagen_l_v1"
      },
      {
        "id": "4001_Kinderwagen_r_v1"
      },
      {
        "id": "4002_Mobilitaetseinschraenkung-Blind_v1"
      },
      {
        "id": "4003_Mobilitaetseinschraenkung-Verletzt_v1"
      },
      {
        "id": "4004_Mobilitaetseinschraenkung-Gebrechlich_v1"
      },
      {
        "id": "4005_Mobilitaetseinschraenkung-Schwanger_v1"
      },
      {
        "id": "5023_Hilferuf_v1"
      },
      {
        "id": "5024_Mobilitaetseinschraenkung-Gehoerlos_v1"
      },
      {
        "id": "5025_Induktive-Kupplung_v1"
      },
      {
        "id": "5026_Elektrische-Kupplung_v1"
      }
    ]
  },
  {
    "id": "04_Dienstleistungen",
    "icons": [
      {
        "id": "3025_Information_v1"
      },
      {
        "id": "3026_Billette_v1"
      },
      {
        "id": "3027_Billettautomat_de_v1"
      },
      {
        "id": "3027_Billettautomat_fr_v1"
      },
      {
        "id": "3027_Billettautomat_it_v1"
      },
      {
        "id": "3028_Geldwechsel_v1"
      },
      {
        "id": "3029_Fundbuero_v1"
      },
      {
        "id": "3030_Gepaeckaufgabe_v1"
      },
      {
        "id": "3031_Gepaeckausgabe_v1"
      },
      {
        "id": "3032_Gepaeck_v1"
      },
      {
        "id": "3033_Gepaeckaufbewahrung_v1"
      },
      {
        "id": "3034_Schliessfach_v1"
      },
      {
        "id": "3035_Warteraum_v1"
      },
      {
        "id": "3036_Bahnhofhilfe_v1"
      },
      {
        "id": "3037_Ceck-in_l_v1"
      },
      {
        "id": "3037_Ceck-in_r_v1"
      },
      {
        "id": "3038_Geldautomat_v1"
      },
      {
        "id": "3039_Touristen-Information_v1"
      },
      {
        "id": "3040_Treffpunkt_v1"
      },
      {
        "id": "3041_Restaurant_v1"
      },
      {
        "id": "3043_Bistro_v1"
      },
      {
        "id": "3044_Shopping_v1"
      },
      {
        "id": "3045_Familienzone_v1"
      },
      {
        "id": "3046_Ruhezone_v1"
      },
      {
        "id": "3047_Businesszone_v1"
      },
      {
        "id": "3048_Reservation_v1"
      },
      {
        "id": "3049_Flugzeugbestuhlung_v1"
      },
      {
        "id": "3050_Gepaeckablage_v1"
      },
      {
        "id": "3051_Garderobe_v1"
      },
      {
        "id": "3052_Skistaender_v1"
      },
      {
        "id": "3053_WLAN_v1"
      },
      {
        "id": "3055_Gepaeck-Schubwagen_v1"
      },
      {
        "id": "3056_Durchsage_v1"
      },
      {
        "id": "3057_Telefon_v1"
      },
      {
        "id": "3059_Notfallnummer_v1"
      },
      {
        "id": "3060_Abflug_l_v1"
      },
      {
        "id": "3060_Abflug_r_v1"
      },
      {
        "id": "3061_Ankunft_l_v1"
      },
      {
        "id": "3061_Ankunft_r_v1"
      },
      {
        "id": "3065_Mobile_v1"
      },
      {
        "id": "4006_Multifunktionsabteil_v1"
      }
    ]
  },
  {
    "id": "01_Auf-Abgaenge",
    "icons": [
      {
        "id": "4007_Treppe-aufwaerts_l_v1"
      },
      {
        "id": "4007_Treppe-aufwaerts_r_v1"
      },
      {
        "id": "4008_Treppe-abwaerts_l_v1"
      },
      {
        "id": "4008_Treppe-abwaerts_r_v1"
      },
      {
        "id": "4009_Rampe-aufwaerts_l_v1"
      },
      {
        "id": "4009_Rampe-aufwaerts_r_v1"
      },
      {
        "id": "4010_Rampe-abwaerts_l_v1"
      },
      {
        "id": "4010_Rampe-abwaerts_r_v1"
      },
      {
        "id": "4011_Rolltreppe-aufwaerts_l_v1"
      },
      {
        "id": "4011_Rolltreppe-aufwaerts_r_v1"
      },
      {
        "id": "4012_Rolltreppe-abwaerts_l_v1"
      },
      {
        "id": "4012_Rolltreppe-abwaerts_r_v1"
      },
      {
        "id": "4013_Lift_v1"
      }
    ]
  },
  {
    "id": "02_Entsorgung_Recycling",
    "icons": [
      {
        "id": "4014_Restmuell_v1"
      },
      {
        "id": "4015_Recycling-Alu_v1"
      },
      {
        "id": "4016_Recycling-Glas_v1"
      },
      {
        "id": "4017_Recycling-PET_v1"
      },
      {
        "id": "4018_Recycling-Papier_v1"
      },
      {
        "id": "4019_Entsorgung-Hygieneartickel_v1"
      }
    ]
  },
  {
    "id": "03_Hygiene",
    "icons": [
      {
        "id": "4020_WC_v1"
      },
      {
        "id": "4021_WC-Barrierefrei_v1"
      },
      {
        "id": "4022_WC-Damen_v1"
      },
      {
        "id": "4023_WC-Herren_v1"
      },
      {
        "id": "4024_Wickeltisch_v1"
      },
      {
        "id": "4025_Trinkwasser_v1"
      },
      {
        "id": "4026_kein-Trinkwasser_v1"
      },
      {
        "id": "4027_Dusche_v1"
      },
      {
        "id": "4028_Trittausloeser_v1"
      },
      {
        "id": "4029_Haendetrockner_v1"
      },
      {
        "id": "4030_Handduecher_v1"
      },
      {
        "id": "4031_Seife_v1"
      },
      {
        "id": "4032_Stuetzhilfe-WC_v1"
      },
      {
        "id": "4037_WC-Unisex_v1"
      },
      {
        "id": "4038_Pissoir_v1"
      }
    ]
  },
  {
    "id": "04_Funktionsweise",
    "icons": [
      {
        "id": "4033_Tueroeffnung_v1"
      },
      {
        "id": "4034_Tueroeffnung-Doppeltuere_v1"
      },
      {
        "id": "4035_Schliesszustand_v1"
      }
    ]
  },
  {
    "id": "01_Gebote_Verbote",
    "icons": [
      {
        "id": "3058_Video-Ueberwachung_v1"
      },
      {
        "id": "5000_Raucher_v1"
      },
      {
        "id": "5001_Nichraucher_v1"
      },
      {
        "id": "5002_Gepaeckschubwagen-Verboten_v1"
      },
      {
        "id": "5003_Gepaeck-Verboten_v1"
      },
      {
        "id": "5004_Mobile-Verboten_v1"
      },
      {
        "id": "5005_Laute-Musik-Verboten_v1"
      },
      {
        "id": "5006_Hunde-Verboten_v1"
      },
      {
        "id": "5007_Hinauslehnen-Verboten_v1"
      },
      {
        "id": "5008_Gegenstaende-Hinauswerfen-Verboten_v1"
      },
      {
        "id": "5009_Betreten-Verboten_v1"
      },
      {
        "id": "5010_Trittbrettfahren-Verboten_v1"
      },
      {
        "id": "5011_Aufspringen-Verboten_v1"
      },
      {
        "id": "5012_Restmuell-und-Hygieneartikel-einwerfen-verboten_v1"
      },
      {
        "id": "5014_Velo-Verboten_l_v1"
      },
      {
        "id": "5014_Velo-Verboten_r_v1"
      },
      {
        "id": "5015_Durchgang-Verboten_v1"
      },
      {
        "id": "5016_Achtung-Sturzgefahr_v1"
      },
      {
        "id": "5017_Achtung-Zug_l_v1"
      },
      {
        "id": "5017_Achtung-Zug_r_v1"
      },
      {
        "id": "5018_Links-gehen-rechts-stehen_v1"
      },
      {
        "id": "5019_Selbstkontrolle_v1"
      },
      {
        "id": "5020_Maximale-Belastung_v1"
      },
      {
        "id": "5021_Baustelle_v1"
      },
      {
        "id": "5022_Zoll_de_v1"
      },
      {
        "id": "5022_Zoll_fr_v1"
      },
      {
        "id": "5022_Zoll_it_v1"
      },
      {
        "id": "5027_Selbstkontrolle_v1"
      }
    ]
  },
  {
    "id": "01_Evakuation",
    "icons": [
      {
        "id": "6000_Notruf_v1"
      },
      {
        "id": "6001_Notausgang_l_v1"
      },
      {
        "id": "6001_Notausgang_r_v1"
      },
      {
        "id": "6002_Defibrilator_v1"
      },
      {
        "id": "6003_Notfallanweisung_v1"
      },
      {
        "id": "6004_Notbremse_v1"
      },
      {
        "id": "6005_Scheibe-hier-einschlagen_v1"
      },
      {
        "id": "6006_Scheibe-herausdruecken_v1"
      },
      {
        "id": "6009_Notleiter_v1"
      },
      {
        "id": "6010_Sammelstelle_v1"
      }
    ]
  },
  {
    "id": "02_Brandbekaempfung",
    "icons": [
      {
        "id": "6007_Feuerloescher_v1"
      }
    ]
  }
]
